import { useEffect, useState, useCallback } from 'react';
import { Login } from './pages/Login';
import { Chat } from './pages/Chat';
import { Cookies } from './pages/Cookies';
import { Health } from './pages/Health';
import { checkAuth } from './lib/api';

type View = 'chat' | 'cookies' | 'health';

function pathToView(pathname: string): View {
  if (pathname === '/health') return 'health';
  if (pathname === '/cookies') return 'cookies';
  return 'chat';
}

export default function App() {
  const [authed, setAuthed] = useState<boolean | null>(null);
  const [view, setView] = useState<View>(() => pathToView(window.location.pathname));

  const navigate = useCallback((v: View) => {
    const path = v === 'chat' ? '/' : `/${v}`;
    window.history.pushState(null, '', path);
    setView(v);
  }, []);

  useEffect(() => {
    const onPop = () => setView(pathToView(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  useEffect(() => {
    checkAuth()
      .then(setAuthed)
      .catch(() => setAuthed(false));
  }, []);

  if (authed === null) {
    return (
      <div className="min-h-full bg-gray-950 text-gray-500 flex items-center justify-center">
        <span className="text-sm">…</span>
      </div>
    );
  }
  if (!authed) {
    return <Login onSuccess={() => setAuthed(true)} />;
  }
  if (view === 'cookies') {
    return <Cookies onBack={() => navigate('chat')} />;
  }
  if (view === 'health') {
    return <Health onBack={() => navigate('chat')} onLogout={() => setAuthed(false)} />;
  }
  return (
    <Chat
      onLogout={() => setAuthed(false)}
      onOpenCookies={() => navigate('cookies')}
      onOpenHealth={() => navigate('health')}
    />
  );
}
